const incidentProgress = (() => {
  let progressTable, progressData;
  function showDeleteConfirmationPopup(message, callback) {
    const popup = POPUP.build({
      classNames: 'setupDeleteConfirmation',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const yesBtn = new Button({
      text: 'Yes',
      style: 'primary',
      styleType: 'contained',
    });
    const noBtn = new Button({
      text: 'No',
      style: 'primary',
      styleType: 'outlined',
    });

    yesBtn.onClick(e => {
      POPUP.hide(popup);
      callback(true);
    });
    noBtn.onClick(e => {
      POPUP.hide(popup);
      callback(false);
    });

    const btnWrapEle = document.createElement('div');
    btnWrapEle.classList.add('btn-wrap');
    yesBtn.renderTo(btnWrapEle);
    noBtn.renderTo(btnWrapEle);

    popup.append(messageEle);
    popup.append(btnWrapEle);

    POPUP.show(popup);
  }
  function showUnableToDeletePopup(message) {
    const popup = POPUP.build({
      classNames: 'unableToDeletePopup',
      hideX: true,
    });

    const messageEle = document.createElement('p');
    messageEle.textContent = message;

    const okBtn = new Button({
      text: 'Ok',
      style: 'primary',
      styleType: 'contained',
    });
    okBtn.onClick(e => {
      POPUP.hide(popup);
    });

    popup.append(messageEle);
    okBtn.renderTo(popup);
    POPUP.show(popup);
  }
  function checkForRequiredFields(formInstance) {
    const invalidElements = [...formInstance.form.querySelectorAll(`input:invalid,select:invalid`),];
    const allElements = [...formInstance.form.querySelectorAll('input:valid, select:valid')];
    const isFormValid = Array.from(allElements).every(field => field.value && field.value.trim() !== '');

    if (invalidElements.length > 0 || !isFormValid) {
      formInstance.buttons['submit'].toggleDisabled(true);
    } else {
      formInstance.buttons['submit'].toggleDisabled(false);
    }
  }

  function showAlreadyExistsWarning(msg, form) {
    const warningPopup = POPUP.build({ hideX: true });
    warningPopup.classList.add('warning');
    const message = document.createElement('p');
    message.innerHTML = msg;
    message.style.marginBottom = '15px';
    const btnWrap = document.createElement('div');
    btnWrap.classList.add('btnWrap');
    const okBtn = button.build({
      text: 'Ok',
      type: 'contained',
      style: 'secondary',
      callback: () => {
        POPUP.hide(warningPopup);
        const overlay = document.querySelector('.overlay');
        if (overlay) overlay.classList.add('visible');
        form.buttons['cancel'].toggleDisabled(false);
      },
    });
    btnWrap.appendChild(okBtn);
    warningPopup.appendChild(message);
    warningPopup.appendChild(btnWrap);
    POPUP.show(warningPopup);
    const closeBtn = warningPopup.querySelector('.closePopupBtn');
    if (closeBtn) closeBtn.remove();
  }
  // Incident Progress
  //-------------------------------------------------------------------------------

  function getIncidentProgressView() {
    const frag = document.createDocumentFragment();
    
    progressTable = table.build({
      tableId: 'accountClassTable',
      columnHeadings: ['Type'],
      endIcon: true,
    });

    const headers = progressTable.querySelectorAll('.header div');
    headers[0].setAttribute('data-type', 'string');

    const addProgressBtnDiv = document.createElement('div');
    const addProgressBtn = new Button({
      text: 'ADD NEW PROGRESS TYPE',
      style: 'primary',
      icon: 'add',
      styleType: 'outlined',
    });

    frag.append(progressTable);
    if ($.session.SetupInsert) {
      addProgressBtn.button.style.float = 'right';
      addProgressBtn.renderTo(addProgressBtnDiv);
      frag.append(addProgressBtnDiv);
    }

    const tableProgressData = progressData
      .map(p => {
        return {
          values: [p.progressName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showProgressPopup(p);
          },
          endIconCallback: () => handleProgressDelete(p),
        };
      });

    table.populate(progressTable, tableProgressData);
    table.sortTableByHeader(progressTable);

    addProgressBtn.onClick(e => {
      showProgressPopup();
    });

    return frag;
  }

  // Incident Progress
  //-------------------------------------------------------------------------------

  function showProgressPopup(rowData) {
    const popup = POPUP.build({
      classNames: 'accountClassPopup',
      hideX: true,
    });

    const progressForm = new Form({
      fields: [
        {
          type: 'text',
          label: 'Type',
          id: 'cName',
          required: true,
        },
      ],
    });

    progressForm.onKeyup(() => {
      checkForRequiredFields(progressForm);
    });
    progressForm.onChange(event => {
      checkForRequiredFields(progressForm);
    });

    progressForm.onSubmit(async formdata => {
      const resp = (
        await _UTIL.fetchData('insertUpdateIncidentProgressData', {
          id: rowData ? rowData.progressId : 0,
          progressName: formdata.cName.trim(),
          userId: $.session.UserId
        })
      ).insertUpdateIncidentProgressDataResult;
      const newID = resp.progressId;
      if (newID == '-1') {
        showAlreadyExistsWarning('This progress type already exists.', progressForm);
        progressForm.buttons['submit'].toggleDisabled(true);
        progressForm.buttons['cancel'].toggleDisabled(true);
      } else {
        progressForm.clear();
        POPUP.hide(popup);
        await getProgressData();
        updateProgressTable();
      }
    });

    progressForm.onCancel(event => {
      progressForm.clear();
      progressForm.buttons['submit'].toggleDisabled(true);
      POPUP.hide(popup);
    });

    progressForm.renderTo(popup);

    POPUP.show(popup);

    progressForm.populate({
      cName: rowData ? rowData.progressName : '',
    });

    progressForm.buttons['submit'].toggleDisabled(true);

    if (!$.session.SetupUpdate && rowData) {
      progressForm.disableFormInputs();
    }
  }

  async function handleProgressDelete(row) {
    const rowData = progressData.find(a => a.progressId == row.progressId);

    if (rowData.isAccountExistCount == 'Y') {
      showUnableToDeletePopup('This progress type is used somewhere else in the system. It cannot be deleted.');
    } else {
      showDeleteConfirmationPopup('Are you sure you want to delete this progress type?', async deleteRecord => {
        if (deleteRecord) {
          await _UTIL.fetchData('deleteIncidentProgressData', {
            token: $.session.Token,
            progressId: row.progressId,
          });

          await getProgressData();
          updateProgressTable();
        }
      });
    }
  }
  function updateProgressTable() {
    const tableProgressData = progressData
      .map(p => {
        return {
          values: [p.progressName],
          endIcon: $.session.SetupDelete ? icons['delete'] : '',
          onClick: e => {
            showProgressPopup(p);
          },
          endIconCallback: () => handleProgressDelete(p),
        };
      });

    table.populate(progressTable, tableProgressData);
  }

  async function getProgressData() {
    const dataProgress = await _UTIL.fetchData('getIncidentProgress');
    progressData = dataProgress.getIncidentProgressResult;
  }


  // Main
  //-------------------------------------------------------------------------------
  async function getView(viewName) {
    const viewFragment = document.createDocumentFragment();
    await getProgressData();

    const viewHeading = document.createElement('h1');
    viewHeading.classList.add('viewHeading');
    viewHeading.textContent = 'Progress';

    const viewBody = document.createElement('div');
    viewBody.classList.add('viewBody');

    let viewMarkup;

    if (viewName === 'Progress') {
      viewMarkup = getIncidentProgressView();
    }

    if (viewMarkup) {
      viewFragment.append(viewHeading);
      viewFragment.append(viewBody);
      viewBody.append(viewMarkup);
    }

    return viewFragment;
  }

  return {
    getView,
  };
})();
